<div class="ui basic segment" [class.loading]="isLoading">
    <app-job-posting-header [jobPosting]="jobPosting" (onChangePause)="onPause($event)"> </app-job-posting-header>

    <app-job-posting-reports-overview-card [jobPosting]="jobPosting"></app-job-posting-reports-overview-card>
    <app-current-funnel-status-report [jobPosting]="jobPosting"></app-current-funnel-status-report>
    <app-application-source-report></app-application-source-report>
</div>
